/**
 * 選択肢と項目名の対応：app-radioの描画用データ
 */
const master = {
    bsc_type: {
        '1': '住宅版',
        '2': '気候風土適応住宅版',      
        '3': '特定建築主基準版'      
    },
    bsc_tatekata: {
        '1': '戸建住宅',
        '2': '共同住宅'
    },
    bsc_kyoshitsu_kousei: {
        '1': '主たる居室とその他の居室、非居室で構成される',
        '2': '上記以外の構成'
    },
    bsc_sonotakyoshitsu: {
        '1': '有',
        '2': '無'
    },
    bsc_hikyoshitsu: {
        '1': '有',
        '2': '無'
    },
    bsc_solarlv_specify: {
        '1': '指定しない',
        '2': '指定する'
    },
    bsc_solarlv: {
        '1': 'A1区分（年間の日射量が特に少ない地域）',
        '2': 'A2区分（年間の日射量が少ない地域）',
        '3': 'A3区分（年間の日射量が中程度の地域）',
        '4': 'A4区分（年間の日射量が多い地域）',
        '5': 'A5区分（年間の日射量が特に多い地域）'
    },
    use_cogen: {
        '1': '設置しない',
        '2': '設置する'
    },
    cogen_type: {
        '1': 'PEFC（固体高分子形燃料電池）',
        '2': 'SOFC（固体酸化物形燃料電池）',
        '4': 'PEFC・SOFCに2015年度以前の評価方法、またはGEC',
    },
    cogen_type_param: {
        '1': 'PEFC',
        '2': 'SOFC',
        '3': 'GEC',
    },
    cogen_package_input: {
        '1': '品番を指定する',
        '2': '品番を指定しない（規定値を用いる）',
        '3': '品番を指定しない（パラメータを入力する）'
    },
    cogen_reverse: {
        '1': '評価しない',
        '2': '評価する'
    },
    cogen_houshiki: {
        '2': 'PEFC1',
        '3': 'PEFC2',
        '4': 'PEFC3',
        '5': 'PEFC4',
        '6': 'PEFC5',
        '11': 'PEFC6',
        '7': 'SOFC1',
        '8': 'SOFC2',
        '9': 'GEC1',
        '10': 'GEC2'
    },
    cogen_bb_type: {
        '1': 'ガス従来型',
        '2': 'ガス潜熱回収型',
    },
    cogen_hainetsu_use: {
        '1': 'なし',
        '2': 'あり'
    },
    cogen_hainetsu_use_type: {
        '1': '給湯優先',
        '2': '暖房優先'
    },
    cogen_reverse_type:{
        '1': 'なし',
        '2': 'あり'
    },
    hv_houshiki: {
        '2': '評価しない、または設置しない',
        '1': '設置する'
    },
    hv_correction_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    ip_houhou: {
        '1': '当該住戸の外皮面積を用いて外皮性能を評価する',
        '2': '当該住戸の外皮面積を用いず外皮性能を評価する（別途計算）',
        '3': '当該住戸の外皮面積を用いず外皮性能を評価する（ここで計算）'
    },
    ip_yuka_dannetsu: {
        '2': '床断熱住戸',
        '1': '基礎断熱住戸'
    },
    ip_structure: {
        '1': '木造',
        '2': '鉄筋コンクリート造等',
        '3': '鉄骨造'
    },
    ip_house_dannetsu: {
        '1': '床断熱住戸',
        '2': '基礎断熱住戸',
        '3': '床断熱住戸と基礎断熱住戸の併用'
    },
    ip_bath_dannetsu: {
        '1': '床断熱',
        '2': '基礎断熱',
        '3': '浴室の床及び基礎が外気等に面していない'
    },
    ip_window_f_input: {
        '1': '規定値を使用する',
        '2': '個別に計算する'
    },
    nw_ldk_houhou: {
        '1': '評価しない、または利用しない',
        '2': '利用する（換気回数5回/h相当以上）',
        '3': '利用する（換気回数20回/h相当以上）'
    },
    nw_nldk_houhou: {
        '1': '評価しない、または利用しない',
        '2': '利用する（換気回数5回/h相当以上）',
        '3': '利用する（換気回数20回/h相当以上）'
    },
    sh_nisshanetsuriyo: {
        '1': '評価しない、または利用しない',
        '2': '利用する'
    },
    ip_ufv: {
        '1': '評価しない、または利用しない',
        '2': '通年利用する'
    },
    ip_ufv_dannetsu: {
        '1': '断熱区画外',
        '2': '断熱区画内'
    },
    cs_houhou: {
        '1': '住戸全体を冷房する',
        '2': '居室のみを冷房する',
        '3': '設置しない'
    },
    cs_ldk_type: {
        '1': 'ルームエアコンディショナー',
        '2': '冷房設備機器を設置しない',
        '3': 'その他の冷房設備機器'
    },
    cs_ldk_type1_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    cs_ldk_aircon_koukouritsu: {
        '1': '区分（い）',
        '2': '区分（ろ）',
        '3': '区分（は）'
    },
    cs_ldk_aircon_dualcompressor: {
        '1': '評価しない、または搭載しない',
        '2': '搭載する',
    },
    cs_nldk_type: {
        '1': 'ルームエアコンディショナー',
        '2': '冷房設備機器を設置しない',
        '3': 'その他の冷房設備機器'
    },
    cs_nldk_type1_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    cs_nldk_aircon_koukouritsu: {
        '1': '区分（い）',
        '2': '区分（ろ）',
        '3': '区分（は）'
    },
    cs_nldk_aircon_dualcompressor: {
        '1': '評価しない、または搭載しない',
        '2': '搭載する',
    },
    cs_type: {
        '1': 'ダクト式セントラル空調機（ヒートポンプ式熱源）'
    },
    cs_dc_duct_dannnetu: {
        '2': '評価しない、または全てもしくは一部が断熱区画外である',
        '1': '全て断熱区画内である',
    },
    cs_dc_vav: {
        '1': '採用しない',
        '2': '採用する',
    },
    cs_dc_general_ventilation: {
        '2': '全般換気機能あり',
        '1': '全般換気機能なし',
    },
    cs_dc_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '定格能力試験の値を入力する',
        '3': '定格能力試験と中間能力試験の値を入力する'
    },
    cs_dc_input_air_flow: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_houhou: {
        '1': '住戸全体を暖房する',
        '2': '居室のみを暖房する',
        '3': '設置しない'
    },
    hs_ldk_type: {
        '4': 'ルームエアコンディショナー',
        '5': 'FF暖房機',
        '6': '電気蓄熱暖房器',
        '7': '電気ヒーター床暖房',
        '10': 'ルームエアコンディショナー付温水床暖房機',
        '2': 'パネルラジエーター',
        '1': '温水床暖房',
        '3': 'ファンコンベクター',
        '9': 'その他の暖房設備機器',
        '8': '暖房設備機器または放熱器を設置しない'
    },
    hs_ldk_aircon_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_ldk_aircon_koukouritsu: {
        '1': '区分（い）',
        '2': '区分（ろ）',
        '3': '区分（は）'
    },
    hs_ldk_aircon_dualcompressor: {
        '1': '評価しない、または搭載しない',
        '2': '搭載する',
    },
    hs_ldk_ff_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_ldk_yuka_fusetsu_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    hs_ldk_heater_fusetsu_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    hs_ldk_racfh_fusetsu_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    hs_ldk_heater_fukinuke: {
        '1': '入力しない',
        '2': '入力する',
    },
    hs_ldk_racfh_fukinuke: {
        '1': '入力しない',
        '2': '入力する',
    },
    hs_ldk_racfh_dannetsu_haikan: {
        '1': '採用する',
        '2': '評価しない、または採用しない',
    },
    hs_ldk_yuka_fukinuke: {
        '1': '入力しない',
        '2': '入力する',
    },
    hs_nldk_type: {
        '4': 'ルームエアコンディショナー',
        '5': 'FF暖房機',
        '6': '電気蓄熱暖房器',
        '7': '電気ヒーター床暖房',
        '10': 'ルームエアコンディショナー付温水床暖房機',
        '2': 'パネルラジエーター',
        '1': '温水床暖房',
        '3': 'ファンコンベクター',
        '9': 'その他の暖房設備機器',
        '8': '暖房設備機器または放熱器を設置しない'
    },
    hs_nldk_aircon_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_nldk_aircon_koukouritsu: {
        '1': '区分（い）',
        '2': '区分（ろ）',
        '3': '区分（は）'
    },
    hs_nldk_aircon_dualcompressor: {
        '1': '評価しない、または搭載しない',
        '2': '搭載する',
    },
    hs_nldk_ff_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_nldk_heater_fusetsu_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    hs_nldk_racfh_fusetsu_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    hs_nldk_yuka_fusetsu_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    hs_nldk_heater_fukinuke: {
        '1': '入力しない',
        '2': '入力する',
    },
    hs_nldk_racfh_dannetsu_haikan: {
        '1': '採用する',
        '2': '評価しない、または採用しない',
    },
    hs_onsuiyuka_netsugen_s: {
        '1': '石油従来型温水暖房機',
        '2': '石油潜熱回収型温水暖房機',
        '3': 'ガス従来型温水暖房機',
        '4': 'ガス潜熱回収型温水暖房機',
        '5': '電気ヒートポンプ温水暖房機（フロン系冷媒）',
        '6': '電気ヒーター温水暖房機',
        '7': '地中熱ヒートポンプ温水暖房機',
        '11': '給湯・温水暖房一体型',
        '12': 'コージェネレーション',
        '13': 'その他の温水暖房機',
        '14': '温水暖房機を設置しない',
    },
    hs_onsuiyuka_gas1_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_onsuiyuka_dannnetu: {
        '1': '採用する',
        '2': '評価しない、または採用しない',
    },
    hs_onsuiyuka_dannnetu_kukaku: {
        '1': '全て断熱区画内である',
        '2': '評価しない、または全てもしくは一部が断熱区画外である',
    },
    hs_onsuiyuka_gas2_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_onsuiyuka_oil_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hs_onsuiyuka_hp_netsukoukan_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    hs_type: {
        '1': 'ダクト式セントラル空調機（ヒートポンプ式熱源）'
    },
    hs_dc_duct_dannnetu: {
        '2': '評価しない、または全てもしくは一部が断熱区画外である',
        '1': '全て断熱区画内である',
    },
    hs_dc_vav: {
        '1': '採用しない',
        '2': '採用する'
    },
    hs_dc_general_ventilation: {
        '2': '全般換気機能あり',
        '1': '全般換気機能なし'
    },
    hs_dc_input: {
        '1': '入力しない（規定値を用いる）',
        '2': '定格能力試験の値を入力する',
        '3': '定格能力試験と中間能力試験の値を入力する'
    },
    hs_dc_input_air_flow: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    hw_setti: {
        '1': '給湯設備がある（浴室等がある）',
        '2': '給湯設備がある（浴室等がない）',
        '3': '給湯設備がない'
    },
    hw_shurui_s: {
        '1': 'ガス従来型給湯機',
        '2': 'ガス潜熱回収型給湯機',
        '3': '石油従来型給湯機',
        '4': '石油潜熱回収型給湯機',
        '5': '電気ヒーター給湯機',
        '6': '電気ヒートポンプ給湯機（CO2冷媒）（太陽熱利用設備を使用しないもの）',
        '7': '電気ヒートポンプ・ガス瞬間式併用型給湯機',
        '11': 'ガス従来型給湯温水暖房機',
        '12': 'ガス潜熱回収型給湯温水暖房機',
        '13': '石油従来型給湯温水暖房機',
        '14': '石油潜熱回収型給湯温水暖房機',
        '15': '電気ヒーター給湯温水暖房機',
        '16': '電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機（暖房部：電気ヒートポンプ・ガス | 給湯部：ガス）',
        '17': '電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機（暖房部：電気ヒートポンプ・ガス | 給湯部：電気ヒートポンプ・ガス）',
        '18': '電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機（暖房部：ガス | 給湯部：電気ヒートポンプ・ガス）',
        '21': 'コージェネレーション',
        '22': 'その他の給湯設備機器',
        '23': '給湯設備機器を設置しない',
    },
    hw_senyo_sr1_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（エネルギー消費効率）を入力',
        '3': '効率（モード熱効率）を入力'
    },
    hw_src_type: {
        '1': '給湯単機能',
        '2': 'ふろ給湯機（追焚なし）',
        '3': 'ふろ給湯機（追焚あり）'
    },
    hw_senyo_sr2_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（エネルギー消費効率）を入力',
        '3': '効率（モード熱効率）を入力'
    },
    hw_senyo_sr3_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（熱効率）を入力',
        '3': '効率（モード熱効率）を入力'
    },
    hw_senyo_sr4_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（熱効率）を入力',
        '3': '効率（モード熱効率）を入力'
    },
    hw_senyo_sr6_spec_method: {
        '1': '品番を指定しない（規定値を用いる）',
        '2': '品番を指定しない（JIS効率を入力する）',
        '3': '品番を指定しない（パラメータを入力する）',
        '4': '品番を指定する',
    },
    hw_senyo_sr7_package_input: {
        '1': '品番を指定する',
        '2': '品番を指定しない（仕様を選択する）',
        '3': '品番を指定しない（パラメータを入力する）',
    },
    hw_senyo_sr7_coolant_type: {
        '1': 'フロン系冷媒',
        '2': 'プロパン系冷媒',
    },
    hw_senyo_sr7_tank: {
        '1': 'タンク容量（小）',
        '2': 'タンク容量（大）',
    },
    hw_ittai_sr11_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（暖房部：熱効率 | 給湯部：エネルギー消費効率）を入力',
        '3': '効率（暖房部：熱効率 | 給湯部：モード熱効率）を入力'
    },
    hw_ittai_sr12_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（暖房部：熱効率 | 給湯部：エネルギー消費効率）を入力',
        '3': '効率（暖房部：熱効率 | 給湯部：モード熱効率）を入力'
    },
    hw_ittai_sr13_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（暖房部：熱効率 | 給湯部：熱効率）を入力',
        '3': '効率（暖房部：熱効率 | 給湯部：モード熱効率）を入力'
    },
    hw_ittai_sr14_taisaku: {
        '1': '入力しない（規定値を用いる）',
        '2': '効率（給湯部：熱効率）を入力',
        '3': '効率（給湯部：モード熱効率）を入力'
    },
    hw_ittai_sr16_tank: {
        '1': '屋内に設置する',
        '2': '屋外に設置する',
    },
    hw_ittai_sr18_package_input: {
        '1': '品番を指定する',
        '2': '品番を指定しない（仕様を選択する）',
        '3': '品番を指定しない（パラメータを入力する）',
    },
    hw_ittai_sr18_coolant_type: {
        '1': 'フロン系冷媒',
        '2': 'プロパン系冷媒',
    },
    hw_ittai_sr18_tank: {
        '1': 'タンク容量（小）',
        '2': 'タンク容量（大）',
    },
    hw_header_type: {
        '1': '評価しない、または先分岐方式',
        '2': 'ヘッダー方式',
    },
    hw_pipesize: {
        '1': 'ヘッダー分岐後のすべての配管径が13A以下',
        '2': 'ヘッダー分岐後のいずれかの配管径が13Aより大きい',
    },
    hw_daidokoro_suisen: {
        '1': '評価しない、または2バルブ水栓',
        '2': '2バルブ水栓以外のその他の水栓',
    },
    hw_daidokoro_temoto: {
        '1': '採用しない',
        '2': '採用する',
    },
    hw_daidokoro_yusen: {
        '1': '採用しない',
        '2': '採用する',
    },
    hw_shower_suisen: {
        '1': '評価しない、または2バルブ水栓',
        '2': '2バルブ水栓以外のその他の水栓',
    },
    hw_shower_temoto: {
        '1': '採用しない',
        '2': '採用する',
    },
    hw_shower_shoryuryo: {
        '1': '採用しない',
        '2': '採用する',
    },
    hw_senmen_suisen: {
        '1': '評価しない、または2バルブ水栓',
        '2': '2バルブ水栓以外のその他の水栓',
    },
    hw_senmen_yusen: {
        '1': '採用しない',
        '2': '採用する',
    },
    hw_yokuso_hoon: {
        '1': '評価しない、または高断熱浴槽を使用しない',
        '2': '高断熱浴槽を使用する',
    },
    ls_main_setti: {
        '1': '設置しない',
        '2': '設置する',
    },
    ls_main_design: {
        '1': 'すべての機器においてLEDを使用している',
        '2': 'すべての機器において白熱灯以外を使用している',
        '3': 'いずれかの機器において白熱灯を使用している'
    },
    ls_main_multi: {
        '1': '評価しない、または採用しない',
        '2': '採用する',
    },
    ls_main_dimming: {
        '2': '評価しない、または採用しない',
        '1': '採用する',
    },
    ls_general_setti: {
        '1': '設置しない',
        '2': '設置する',
    },
    ls_general_device: {
        '1': 'すべての機器においてLEDを使用している',
        '2': 'すべての機器において白熱灯以外を使用している',
        '3': 'いずれかの機器において白熱灯を使用している'
    },
    ls_general_dimming: {
        '2': '評価しない、または採用しない',
        '1': '採用する',
    },
    ls_other_setti: {
        '1': '設置しない',
        '2': '設置する',
    },
    ls_other_device: {
        '1': 'すべての機器においてLEDを使用している',
        '2': 'すべての機器において白熱灯以外を使用している',
        '3': 'いずれかの機器において白熱灯を使用している'
    },
    ls_other_control: {
        '2': '評価しない、または採用しない',
        '1': '採用する',
    },
    pv_saiyou: {
        '2': '評価しない、または設置しない',
        '1': '設置する'
    },
    pv_pcs_koritsu: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する'
    },
    pv_panel_shurui: {
        '1': '結晶シリコン系太陽電池',
        '2': '結晶シリコン系以外の太陽電池'
    },
    pv_panel_setti: {
        '1': '架台設置形',
        '2': '屋根置き形',
        '3': 'その他'
    },
    pv_panel_houi: {
        '1': '真南から東および西へ15度未満',
        '2': '真南から東へ15度以上45度未満',
        '3': '真南から東へ45度以上75度未満',
        '4': '真南から東へ75度以上105度未満',
        '5': '真南から東へ105度以上135度未満',
        '6': '真南から東へ135度以上165度未満',
        '7': '真南から東および西へ165度以上真北まで',
        '8': '真南から西へ135度以上165度未満',
        '9': '真南から西へ105度以上135度未満',
        '10': '真南から西へ75度以上105度未満',
        '11': '真南から西へ45度以上75度未満',
        '12': '真南から西へ15度以上45度未満'
    },
    pv_panel_keisha: {
        '1': '0度（水平）',
        '2': '10度',
        '3': '20度',
        '4': '30度',
        '5': '40度',
        '6': '50度',
        '7': '60度',
        '8': '70度',
        '9': '80度',
        '10': '90度（鉛直）',
    },
    vn_houshiki: {
        '1': 'ダクト式第一種換気設備',
        '2': 'ダクト式第二種換気設備、またはダクト式第三種換気設備',
        '3': '壁付け式第一種換気設備',
        '4': '壁付け式第二種換気設備、または壁付け式第三種換気設備',
    },
    vn_duct_houhou: {
        '1': '入力しない（省エネルギー手法を評価しない、または採用しない）',
        '2': '入力しない（省エネルギー手法を採用する）',
        '3': '入力する',
    },
    vn_duct_method: {
        '1': '径の太いダクトを使用する',
        '2': '径の太いダクトを使用し、かつDCモーターを採用する',
    },
    vn_other_houhou: {
        '1': '入力しない（規定値を用いる）',
        '2': '入力する',
    },
    vn_freq: {
        '1': '0.5回/h',
        '2': '0.7回/h',
        '3': '0.0回/h',
    },
    vn_e_input: {
        '1': '還気が給気に混入することのない場合、\nもしくは熱交換型換気設備を評価しない、または設置しない場合（規定値を用いる）',
        '2': '上記以外の場合',
    },
    sw_saiyou: {
        '1': '設置する',
        '2': '評価しない、または設置しない',
    },
    sw_sr: {
        '1': '太陽熱温水器',
        '2': 'ソーラーシステム',
    },
    sw_sr1_menseki: {
        '1': '集熱部総面積、または集熱貯湯部総面積を入力する',
        '2': '有効集熱面積を入力する',
    },
    sw_sr1_angle: {
        '1': '真南から東および西へ15度未満',
        '2': '真南から東へ15度以上45度未満',
        '3': '真南から東へ45度以上75度未満',
        '4': '真南から東へ75度以上105度未満',
        '5': '真南から東へ105度以上135度未満',
        '6': '真南から東へ135度以上165度未満',
        '7': '真南から東および西へ165度以上真北まで',
        '8': '真南から西へ135度以上165度未満',
        '9': '真南から西へ105度以上135度未満',
        '10': '真南から西へ75度以上105度未満',
        '11': '真南から西へ45度以上75度未満',
        '12': '真南から西へ15度以上45度未満'
    },
    sw_sr1_slope: {
        '1': '0度（水平）',
        '2': '10度',
        '3': '20度',
        '4': '30度',
        '5': '40度',
        '6': '50度',
        '7': '60度',
        '8': '70度',
        '9': '80度',
        '10': '90度（鉛直）',
    },
    sw_sr2_menseki: {
        '1': '集熱器総面積を入力する',
        '2': '有効集熱面積を入力する',
    },
    om_saiyou: {
        '2': '評価しない、または設置しない',
        '1': '設置する',
    },
    om_fan_jirituunten: {
        '1': '採用する',
        '2': '採用しない'
    },
    om_fan_type: {
        '1': 'DCファン',
        '2': 'ACファン'
    },
    om_hw_saiyou: {
        '1': '利用する',
        '2': '利用しない'
    },
    om_supply_target: {
        '1': '床下空間',
        '2': '床下空間以外の室内空間'
    },
    om_panel_input: {
        '2': '入力しない（規定値を用いる）',
        '1': '入力する'
    }
}

export default {
    data() {
        return {
            master
        }
    }
}